import { __extends } from "tslib";
import { EventDispatcher } from '../events/EventDispatcher';
import { axCoerceString } from '@awayjs/graphics';
// Class: FrameLabel
var FrameLabel = /** @class */ (function (_super) {
    __extends(FrameLabel, _super);
    function FrameLabel(name, frame /*int*/) {
        var _this = _super.call(this) || this;
        _this._name = axCoerceString(name);
        _this._frame = frame | 0;
        return _this;
    }
    Object.defineProperty(FrameLabel.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FrameLabel.prototype, "frame", {
        get: function () {
            return this._frame;
        },
        enumerable: true,
        configurable: true
    });
    FrameLabel.prototype.clone = function () {
        return new FrameLabel(this._name, this._frame);
    };
    // Called whenever the class is initialized.
    FrameLabel.classInitializer = null;
    return FrameLabel;
}(EventDispatcher));
export { FrameLabel };
